import type { DetailFieldProps } from "./types-detail-field";

/** Par rótulo + valor, somente leitura: valor ausente fica em branco e sem link. */
export function useDetailField({
  label,
  value,
  startsRow = false,
  href,
  hint,
  variant = "grade",
  testId,
}: DetailFieldProps) {
  const hasValue = value !== null && value !== "";

  return {
    label,
    testId,
    variant,
    startsRow,
    hint,
    valor: hasValue ? value : "",
    href: hasValue ? href : undefined,
  };
}
